import { RSAA } from 'redux-api-middleware';

import {
  GET_INSTANCESV4_REQUESTED,
  GET_INSTANCESV4_FAILURE,
  GET_INSTANCESV4_SUCCESS,
} from '../actions';

const getInstancesORv4ActionSet = () => ({
  [RSAA]: {
    types: [GET_INSTANCESV4_REQUESTED, GET_INSTANCESV4_SUCCESS, GET_INSTANCESV4_FAILURE],
    method: 'GET',
    endpoint: '/orv4/instances/',
  },
});

/**
 * Retrieves a list of instances from ORv4
 */
export const getInstancesORv4 = () => (dispatch) => dispatch(getInstancesORv4ActionSet());

export default getInstancesORv4;
